import React, { memo } from 'react';
import cx from 'classnames';
import { nfn } from '../../common';
import { omit, get } from 'lodash';

export function Column({
  data,
  index,
  rowIndex,
  open,
  lineHeight,
  checked,
  config = {}
}) {
  const {
    key,
    render,
    align = 'left',
    limit,
    width,
    colSpanFn,
    rowSpanFn,
    colStyle = {},
    className
  } = config;
  const columnData = get(data, key);
  let styleName = '';
  if (typeof className === 'function') {
    styleName = className(data);
  } else {
    styleName = className;
  }
  const cls = cx('table-row-item', styleName, {
    pdl10: true,
    pdr10: true,
    limit
  });
  const content = render
    ? render(columnData, data, {
        rowIndex,
        columnIndex: index,
        expandShow: open,
        checked
      })
    : columnData;
  let colSpan = 1;
  let rowSpan = 1;

  if (colSpanFn) {
    colSpan = colSpanFn(columnData, data, {
      rowIndex,
      columnIndex: index,
      expandShow: open,
      checked
    });
  }

  if (rowSpanFn) {
    rowSpan = rowSpanFn(columnData, data, {
      rowIndex,
      columnIndex: index,
      expandShow: open,
      checked
    });
  }

  if (content === null) {
    return '';
  }

  // 当rowSpan = 0 时，视为合并
  if (rowSpan === 0) {
    return '';
  }

  let style = colStyle;
  // style类型
  if (typeof colStyle === 'function') {
    style =
      colStyle({
        data,
        rowIndex,
        columnIndex: index,
        expandShow: open,
        checked
      }) || {};
  }

  return (
    <td
      className={cls}
      colSpan={colSpan}
      rowSpan={rowSpan}
      style={{
        height: lineHeight,
        textAlign: align || 'center',
        maxWidth: width,
        ...style
      }}
    >
      {content}
    </td>
  );
}

function Row({
  columns,
  data,
  index,
  open,
  className,
  lineHeight,
  striped,
  onClick,
  checked,
  setRowClassFn,
  totalData,
  draggable,
  rowStyle = {},
  selectRowBgColor,
  ...others
}) {
  const cls = cx(
    'table-body-row',
    className,
    {
      active: checked,
      striped,
      checked
    },
    setRowClassFn ? setRowClassFn(data) : false
  );
  const onRowClick = () => onClick(data, index, totalData);
  const columnProps = {
    data,
    rowIndex: index,
    lineHeight,
    open
  };

  let style = rowStyle;
  // style类型
  if (typeof rowStyle === 'function') {
    style =
      rowStyle({
        data,
        expandShow: open,
        checked
      }) || {};
  }

  return (
    <tr
      className={cls}
      draggable={draggable}
      onClick={onRowClick}
      style={{
        height: lineHeight,
        backgroundColor: checked && selectRowBgColor,
        ...style
      }}
      {...omit(others, ['flatColumns'])}
    >
      {columns.map((column, i) => (
        <Column
          key={`table-row-item-${index}-${i}`}
          {...columnProps}
          config={column}
          checked={checked}
          index={i}
        />
      ))}
    </tr>
  );
}

Row.defaultProps = {
  onClick: nfn
};

export default memo(Row);
